var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { camelCase, get } from 'lodash-es';
import DoconModal, { Content, Footer } from './index';
import { Heading4, Body1 } from '../doconHeadings/doconHeadings';
import { BaseBox, FlexBox } from '../../shared/Element';
import * as Icons from '../../shared/icons/StateIcon';
import { doconTheme } from "../../../theme/default";
export var Icon;
(function (Icon) {
    Icon["error"] = "ErrorIcon";
    Icon["warning"] = "WarningIcon";
    Icon["info"] = "InfoIcon";
    Icon["success"] = "SuccessIcon";
})(Icon || (Icon = {}));
function handleBarColors(_a) {
    var _b;
    var theme = _a.theme, $type = _a.$type;
    var colored = (((_b = theme === null || theme === void 0 ? void 0 : theme.v2) === null || _b === void 0 ? void 0 : _b.toast) || doconTheme.v2.toast).colored;
    return "\n    --icon-color: " + colored[camelCase("text_color_" + $type)] + ";\n  ";
}
var Modal = styled(DoconModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  --leftRightPadding: 30px;\n  ", ";\n\n  ", " {\n    padding: 30px var(--leftRightPadding);\n  }\n\n  ", " {\n    padding-right: var(--leftRightPadding);\n  }\n\n  ", " {\n    margin-bottom: 4px;\n  }\n"], ["\n  --leftRightPadding: 30px;\n  ", ";\n\n  ", " {\n    padding: 30px var(--leftRightPadding);\n  }\n\n  ", " {\n    padding-right: var(--leftRightPadding);\n  }\n\n  ", " {\n    margin-bottom: 4px;\n  }\n"])), function (props) { return handleBarColors(props); }, Content, Footer, Heading4);
var ConfirmModal = function (_a) {
    var type = _a.type, title = _a.title, description = _a.description, 
    // okText,
    children = _a.children, props = __rest(_a, ["type", "title", "description", "children"]);
    var IconNode = Icons[Icon[type]];
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Modal, __assign({ hideCrossIcon: true, maskClosable: false, escapeClosable: false, "$type": type, cancelText: null }, props),
            React.createElement(FlexBox, null,
                IconNode ? (React.createElement(IconNode, { width: 20, height: 20, mt: '4px', type: type, color: 'var(--icon-color)' })) : null,
                React.createElement(BaseBox, { flex: 1, ml: '16px' },
                    React.createElement(Heading4, { title: title, fontWeight: 600 }),
                    React.createElement(Body1, { title: description, color: get(doconTheme, 'v2.colors.text.secondaryColor') }),
                    children)))));
};
export default styled(ConfirmModal)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
